import { motion } from "framer-motion";
import { Logo } from "./Logo";

export const Nav = () => (
  <motion.header
    initial={{ y: -30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, delay: 0.1 }}
    className="fixed top-0 inset-x-0 z-50"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-4">
      <div className="flex items-center justify-between rounded-full bg-ink/70 backdrop-blur-xl border border-cream/10 pl-3 pr-2 py-2">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-cream/80 text-sm font-semibold">
          <a href="#book" data-testid="nav-book-link" className="hover:text-butter transition-colors">The Book</a>
          <a href="#reuben" data-testid="nav-author-link" className="hover:text-butter transition-colors">Meet Reuben</a>
        </nav>
        <a
          href="#buy"
          data-testid="nav-buy-button"
          className="whitespace-nowrap rounded-full bg-coral text-cream font-bold px-5 py-2.5 text-sm hover:bg-butter hover:text-ink transition-colors duration-300"
        >
          Buy the book
        </a>
      </div>
    </div>
  </motion.header>
);
